<span
  [ngbPopover]="popoverContent"
  [disablePopover]="disablePopover"
  [popoverClass]="popoverClass"
  [triggers]="triggers"
  container="body"
  [ngClass]="additionalClasses">
  <ng-content></ng-content>
</span>
